import { lazy } from 'react';

// project imports
import AuthLayout from '../layout/Auth';
import Loadable from '../components/Loadable';

// jwt auth
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/auth',
  element: <AuthLayout />,
  children: [
    { path: 'login', element: <AuthLogin /> },
    { path: 'forgot-password', element: <AuthForgotPassword /> },
    { path: 'reset-password', element: <AuthResetPassword /> },
    { path: 'code-verification', element: <AuthCodeVerification /> }
  ]
};

export default LoginRoutes;
